import { render, staticRenderFns } from "./ObiFloatingInput.vue?vue&type=template&id=4730d439&scoped=true&"
import script from "./ObiFloatingInput.vue?vue&type=script&lang=js&"
export * from "./ObiFloatingInput.vue?vue&type=script&lang=js&"
import style0 from "./ObiFloatingInput.vue?vue&type=style&index=0&id=4730d439&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4730d439",
  null
  
)

export default component.exports